import instance from "../utils/network";
export interface PushRes {
  id: number;
  createdAt: string;
  updatedAt: string;
  title: string;
  description: string;
  sendDate: string;
  pubId: number;
  target: PushTargetType;
  state: PushState;
  data: string;
  pushCount: number;
}

export interface PushReq {
  title: string | null;
  description: string | null;
  sendDate: string | null;
  pubId: number;
  target: PushTargetType | null;
  state: PushState;
  data: string;
}

export enum PushTargetType {
  ALL = "ALL",
  PINPOINT = "PINPOINT",
}

export enum PushState {
  RESERVATION = "RESERVATION",
  SEND = "SEND",
  TEMPORARY = "TEMPORARY",
}

export interface PushResPaging {
  total: number;
  pushes: PushRes[];
}

export interface PushGeoLocationResponse {
  withinOneHour: number;
  withinTwoHours: number;
}

export function getPushList(pubId: number): Promise<PushRes[]> {
  return instance.get(`/seller/push/${pubId}`);
}

export function getPinCount(pubId: number): Promise<number> {
  return instance.get(`/seller/pub-grade/push-count/${pubId}`);
}

export function getPushDetail(id: number): Promise<PushRes> {
  return instance.get(`/seller/push/detail/${id}`);
}

export function getAroundCount(
  lat: number,
  lon: number
): Promise<PushGeoLocationResponse> {
  return instance.get(`/seller/push/around/count?lat=${lat}&lon=${lon}`);
}

export function sendPush(
  data: PushReq
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/push`, data);
}

export function sendTemporaryPush(
  id: number,
  data: PushReq
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/push/${id}`, data);
}
